import { isFilename } from '__core/shared/util/validate';
import template from './attachmentRename.template.html';

export default {
  bindings: {
    onFinished: '&'
  },
  controller: class controller {
    constructor($mdDialog, $mdMedia, eventService, uiService, Document) {
      'ngInject';
      /*
       * Controller Model
       * --------------------------------------------------------------------------------
       */
      const ctrl = this;
      ctrl.$mdDialog = $mdDialog;
      ctrl.$mdMedia = $mdMedia;
      ctrl.destroyWatch = null;

      /*
       * Methods
       * --------------------------------------------------------------------------------
       */
      ctrl.initialize = () => {
        ctrl.destroyWatch = eventService.onAttachmentRename((params) => {
          $mdDialog
            .show({
              targetEvent: params.event,
              locals: {
                attachment: params.attachment
                  ? angular.copy(params.attachment)
                  : Document.blank()
              },
              template,
              controllerAs: '$ctrl',
              controller(attachment) {
                const ctr = this;
                ctr.attachment = attachment;
                ctr.attachmentName = attachment.getNameWithoutExtension();
                ctr.attachmentExtension = attachment.getFileExtension();

                ctr.confirm = () => {
                  if (ctr.attachmentName !== '') {
                    if (isFilename(ctr.attachmentName)) {
                      ctr.attachment.name = `${ctr.attachmentName}.${ctr.attachmentExtension}`;
                      $mdDialog.hide(ctr.attachment);
                    } else {
                      uiService.toast({
                        text: {
                          p1: 'File',
                          p2: 'name',
                          p3: 'contains invalid characters'
                        },
                        warn: true
                      });
                    }
                  } else {
                    uiService.toast({
                      text: {
                        p1: 'File',
                        p2: 'name',
                        p3: 'is required'
                      },
                      warn: true
                    });
                  }
                };

                ctr.cancel = () => {
                  $mdDialog.cancel();
                };
              }
            })
            .then((attachment) => {
              ctrl.onFinished({ attachment });
            });
        });
      };

      /*
       * Execute when all bindings are completed
       * --------------------------------------------------------------------------------
       */
      ctrl.$onInit = () => {
        ctrl.initialize();
      };

      /*
       * Execute when component is not necessary anymore
       * --------------------------------------------------------------------------------
       */
      ctrl.$onDestroy = () => {
        ctrl.destroyWatch();
      };
    }
  }
};
